import React from "react";
import { Container, Row, Col} from "react-bootstrap";
import BenefitImg from "../../../Images/benefits.png";
import'./PartnerBenefit.css';
function PartnerBenefit(){
    return(
        <>
            <section className="benefit-sc">
                <Container>
                    <Row className="align-items-center">
                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="benefit-img">
                                <img src={BenefitImg} alt="BenefitImg" className="img-fluid" />
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                            <h2 className="pageinnerhead">Benefits To The Customers</h2>
                            <ul className="partner-form-data">
                                {/* <li>Get Interest on your Ledger balance.</li> */}
                                <li>Brokerage as low as Rs 10 per order</li>
                                <li>Get account open in 5 minutes.</li>
                                <li>Low cost Algo trading.</li>
                                <li>Dedicated Support Team</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default PartnerBenefit;